// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { GuidelineAccount } from './guideline-account';
import { GuidelineContext } from './guideline-context';
import { GuidelineOverride } from './guideline-override';
import { GuidelineProgram } from './guideline-program';
import { GuidelineSupplier } from './guideline-supplier';
import { ActiveStatusEnum } from './enums';
import { GuidelineContextEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Guideline extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Enum FK guidelineContext */
  guidelineContextId!: GuidelineContextEnum;
  /** String */
  instruction!: string;
  /** Boolean */
  isAllAccounts!: boolean;
  /** Boolean */
  isAllPrograms!: boolean;
  /** Boolean */
  isAllSuppliers!: boolean;
  /** Binary */
  rowVersion!: any;
  /** String(250) */
  title?: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK guidelineId */
  guidelineAccounts!: GuidelineAccount[];
  /** FK guidelineContextId */
  guidelineContext!: GuidelineContext;
  /** Inv FK guidelineId */
  guidelineOverrides!: GuidelineOverride[];
  /** Inv FK guidelineId */
  guidelinePrograms!: GuidelineProgram[];
  /** Inv FK guidelineId */
  guidelineSuppliers!: GuidelineSupplier[];
}

